import React from 'react'
import NKModal from './NKModal.jsx'

const JaNeiDialog = React.createClass({
    propTypes: {
        melding: React.PropTypes.string.isRequired
    },
    getInitialState: function () {
        return { isOpen: true };
    },
    closeModal: function () {
        this.props.isOpen = false; 
    },
    render() {

        return (            
                <NKModal size='small'
                    isOpen={this.props.isOpen}                    
                    >
                    <div className="modal-content">
                        <div className="modal-header modal-header-info">
                            <h4 className="modal-title">{this.props.tittel}</h4>                            
                        </div>
                        <div className="modal-body">
                            <h3><small> {this.props.melding}</small> </h3>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-primary" onClick={this.props.onOk}>{this.props.okKnappTekst ?this.props.okKnappTekst  : 'Ok'}</button>
                            <button className="btn btn-default" onClick={this.props.onAvbryt}>Avbryt</button>
                        </div>

                    </div>
                </NKModal>            
        );
    }
});

export default JaNeiDialog;


// WEBPACK FOOTER //
// ./src/felles/Dialogs/JaNeiDialog.jsx